import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { ButtonModule } from '@purespectrum1/ui/button';

import { SearchPipe } from './search-pipe/search.pipe';
import { SelectDropdownComponent } from './select-dropdown.component';
import { SelectDropdownItemComponent } from './select-dropdown-item/select-dropdown-item.component';
import { SelectDropdownDirective } from './select-dropdown-directive/select-dropdown.directive';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SelectDropdownIconDirective } from './select-dropdown-icon-directive/select-dropdown-icon.directive';
import { SelectDropdownActionDirective } from './select-dropdown-action-directive/select-dropdown-action.directive';
import { FlagModule } from '@purespectrum1/ui/flag';

export * from './search-pipe/search.pipe';
export * from './select-dropdown.component';
export * from './select-dropdown-item/select-dropdown-item.component';
export * from './select-dropdown-directive/select-dropdown.directive';
export * from './select-dropdown-icon-directive/select-dropdown-icon.directive';
export * from './select-dropdown-action-directive/select-dropdown-action.directive';

@NgModule({
  declarations: [
    SearchPipe,
    SelectDropdownComponent,
    SelectDropdownItemComponent,
    SelectDropdownDirective,
    SelectDropdownIconDirective,
    SelectDropdownActionDirective,
  ],
  exports: [
    SearchPipe,
    SelectDropdownComponent,
    SelectDropdownItemComponent,
    SelectDropdownDirective,
    SelectDropdownIconDirective,
    SelectDropdownActionDirective,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    ScrollingModule,
    FormsModule,
    FlagModule,
  ],
})
export class SelectDropdownModule {}
